import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { ICourse } from '../../../models/courses.model'
import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/program/course/Editor';
import useAxios from '../../../hooks/useAxios';
import ErrorResponse from '../../../components/ErrorResponse';
import { createCourse } from '../../../api/courses.api';
import useNotification from '../../../hooks/useNotification';

const ProgramCourseCreate: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.create'));
      history.push(`/program/course${location.search}`);
    }
  }, [submitRes]);

  const submit = async (req: ICourse) => {
    submitExecute(createCourse(req));
  };

  return (
    <div className="content scrollbar">
      {submitIsLoading && <Loader />}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={t('program.course.title2')}
      />
      <Editor
        submit={submit}
      />
      <Footer />
    </div>
  )
}

export default ProgramCourseCreate;
